export const tradelist_api = {
  url: 'prdlists',
  method: 'post',
  title: '商品列表',
  query: [],
  param: {
    business: 'cefine', //商家
    store: 'cefine海外旗舰店', //店铺名
    profession: '美妆个护', //行业
    spuCode: '', //SPU
    skuCode: '', //SKU
    title: '' //商品名
  },
  pagenum: 1,
  pagesize: 10
}

// 导出
export const list_api = {
  url: 'orderLists',
  method: 'post',
  title: ''
}

// 导出
export const export_api = {
  url: 'orderListsDownload',
  method: 'post',
  title: '导出'
}

export const delprditem_api = {
  url: 'delprditem',
  method: 'POST',
  title: '商品删除'
}
export const upload_api = {
  url: 'importprditem',
  method: 'POST',
  title: '商品导入'
}



// WEBPACK FOOTER //
// ./src/views/rfm/rfmPrdList/desc.js